import type { MapMarkerData, MapSegmentData } from '~/components/map';
import type { TripOverviewStay } from '~/services/engine-ts';
import type { GeoCoordinates } from '~/types/GeoLocation.types';

export type AccommodationStaysMapData = {
  markers: MapMarkerData[];
  segments: MapSegmentData[];
  route: GeoCoordinates[];
};

const isValidCoordinate = ({ latitude, longitude }: GeoCoordinates) =>
  Number.isFinite(latitude) && Number.isFinite(longitude) && !(latitude === 0 && longitude === 0);

const markerPosition = (index: number, lastIndex: number): MapMarkerData['position'] => {
  if (index === 0) return 'start';
  if (index === lastIndex) return 'end';
  return 'middle';
};

export const tripAccommodationStaysToMapData = (stays: TripOverviewStay[]): AccommodationStaysMapData => {
  const withCoords = stays.filter((stay) => isValidCoordinate(stay.place.geoCoordinates));
  if (withCoords.length === 0) {
    return { markers: [], segments: [], route: [] };
  }

  const route = withCoords.map((stay) => stay.place.geoCoordinates);
  const lastIndex = withCoords.length - 1;

  const markers: MapMarkerData[] = withCoords.map((stay, index) => ({
    id: `stay-${stay.itemId}`,
    icon: 'bed',
    position: markerPosition(index, lastIndex),
    coordinates: stay.place.geoCoordinates,
    label: stay.place.name,
    progressAt: lastIndex === 0 ? 0 : index / lastIndex
  }));

  const segments: MapSegmentData[] = [];
  for (let i = 0; i < withCoords.length - 1; i++) {
    segments.push({
      id: `stay-segment-${withCoords[i].itemId}-${withCoords[i + 1].itemId}`,
      origin: withCoords[i].place.geoCoordinates,
      destination: withCoords[i + 1].place.geoCoordinates
    });
  }

  return { markers, segments, route };
};
